import { useAccount } from "@/composables/account/useAccount";
import { useAccountFeatureFlags } from "@/composables/useAccountFeatureFlags";

/** Account fetch plus the compliance_groups_demo_enabled gate every demo view checks. */
export const useComplianceAccess = () => {
  const { accountData, loaded } = useAccount();
  const { hasFlag } = useAccountFeatureFlags(accountData);
  const enabled = hasFlag("compliance_groups_demo_enabled");
  return { loaded, enabled };
};
